import CrudRepository from './CrudRepository'
export default class InvestorRelationSliderRepository extends CrudRepository {
  constructor () {
    super('customerCare/api/investor/web')
  }
}
